import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Typography,
  Grid,
  CircularProgress,
  TextField,
} from "@mui/material";

import { useMediaQuery, useTheme } from "@mui/material";

import { useSnackbar } from "notistack";

import Logo from "@assets/images/logo.png";

import { CognitoAPI } from "@services/API";

export default function ForgotPassword({ ...props }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const history = useHistory();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const isValidEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const handleReset = (event) => {
    event.preventDefault();

    if (isNullOrEmpty(email)) {
      showSnackBar("error", "Failure", "Email can't be empty.");
    } else if (!isValidEmail(email)) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else {
      setLoading(true);

      CognitoAPI.post(`/forgotpassword`, {
        UserName: email.trim(),
      })
        .then((response) => {
          setLoading(false);
          if (response.data.token) {
            localStorage.setItem("email", email);
            history.push("/resetpassword");
          }
        })
        .catch((error) => {
          setLoading(false);
          showSnackBar("error", "Failure", "Internal server error.");
        });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
      }}
    >
      <Grid
        container
        spacing={2}
        style={{ width: isSmallScreen ? "90%" : "500px" }}
      >
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img src={Logo} alt="logo" height="100px" />
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Typography
            variant="h3"
            color={"primary"}
            style={{ fontWeight: "bold" }}
          >
            Administration Portal
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography>
            Enter the email address you use to access the system and a
            confirmation code will be sent to you, that will allow you to reset
            your password.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            id="email"
            label="Email"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            autoFocus={true}
            required={true}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            type={"submit"}
            size={"large"}
            loading={loading}
            disabled={loading}
            onClick={handleReset}
            fullWidth
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Reset Password"
            )}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
